<template>
  <section
    class="boxAgradecimento"
    :class="{ 'boxAgradecimento--compact': compact }"
  >
    <div class="boxAgradecimento__hero">
      <img
        class="boxAgradecimento__photo"
        :src="randomPhoto"
        alt=""
        draggable="false"
        @contextmenu.prevent
        @dragstart.prevent
      />
      <div class="boxAgradecimento__copy">
        <div class="textHeader">Tudo certo!</div>
        <div class="textBody">
          Agradecemos pela preferência!<br />
          Aproveite suas fotos =D
        </div>
      </div>
    </div>

    <TotemProductShowcase />

    <button
      class="boxAgradecimento__finish"
      type="button"
      @click="$emit('finish')"
    >
      Finalizar
    </button>
  </section>
</template>

<script>
import TotemProductShowcase from "@/components/TotemProductShowcase.vue";

export default {
  name: "BoxAgradecimento",
  components: { TotemProductShowcase },
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      randomGif: [
        {
          src: "https://media2.giphy.com/media/RQSuZfuylVNAY/giphy.gif?cid=ecf05e478vx2523bgsl4j9kbnsvyiiwupe9qqzcarnwpjqde&rid=giphy.gif&ct=g",
        },
        {
          src: "https://media1.giphy.com/media/dTJd5ygpxkzWo/giphy.gif?cid=ecf05e478vx2523bgsl4j9kbnsvyiiwupe9qqzcarnwpjqde&rid=giphy.gif&ct=g",
        },
        {
          src: "https://media2.giphy.com/media/3lxD1O74siiz5FvrJs/giphy.gif?cid=ecf05e471yp3eve9vxvovh7yok94eafnp82f0aampj196hit&rid=giphy.gif&ct=g",
        },
        {
          src: "https://media0.giphy.com/media/VbnUQpnihPSIgIXuZv/giphy.webp?cid=ecf05e47hnxihl72vnwzqt5krgox27lfcoa9v6wu106lk97f&rid=giphy.webp&ct=g",
        },
        {
          src: "https://media0.giphy.com/media/v6aOjy0Qo1fIA/giphy.webp?cid=ecf05e47hnxihl72vnwzqt5krgox27lfcoa9v6wu106lk97f&rid=giphy.webp&ct=g",
        },
        {
          src: "https://media0.giphy.com/media/xThtadSLoInlcD1UmA/giphy.webp?cid=ecf05e47kjne03whc7jtw9rgz0y6hgwrdutkqla9qhwqgvcs&rid=giphy.webp&ct=g",
        },
        {
          src: "https://media1.giphy.com/media/uWlpPGquhGZNFzY90z/giphy.gif?cid=ecf05e477s1k33a026oxtmi5w9uqddau5lyl7e769yrs92iv&rid=giphy.gif&ct=g",
        },
        {
          src: "https://media2.giphy.com/media/ej4lfadivQe1W/giphy.webp?cid=ecf05e47ubwyfcixi2zo2f64dr606v3775y5s4tjs1dfwfrn&rid=giphy.webp&ct=g",
        },
        {
          src: "https://media0.giphy.com/media/RhrAmVUHxjTQvEPBWi/giphy.webp?cid=ecf05e47555eqcjgzgpom6e5tp46ggqsx75eyazmn4pwhcb8&rid=giphy.webp&ct=g",
        },
      ],
    };
  },
  computed: {
    randomPhoto() {
      let randomID = Math.floor(Math.random() * this.randomGif.length);
      return this.randomGif[randomID]?.src || this.randomGif[0].src;
    },
  },
};
</script>

<style lang="scss" scoped>
.boxAgradecimento {
  background: #ffffff;
  border-radius: 28px;
  box-shadow: 0 12px 34px rgba(75, 39, 93, 0.32);
  margin: auto;
  max-width: 1160px;
  padding: 26px;
  width: 92%;
}

.boxAgradecimento__hero {
  align-items: center;
  display: grid;
  gap: 28px;
  grid-template-columns: minmax(220px, 38%) 1fr;
}

.boxAgradecimento__photo {
  border-radius: 20px;
  display: block;
  height: 220px;
  object-fit: cover;
  object-position: top;
  width: 100%;
}

.boxAgradecimento__copy {
  text-align: center;
}

.textHeader {
  color: #8c2667;
  font-size: 50px;
  font-weight: 300;
  line-height: 1.05;
}

.textBody {
  color: #8c2667;
  font-size: 27px;
  font-weight: 700;
  line-height: 1.3;
  margin-top: 20px;
}

.boxAgradecimento__finish {
  background: #ff006b;
  border: 0;
  border-radius: 999px;
  box-shadow: 0 7px 18px rgba(255, 0, 107, 0.25);
  color: #fff;
  display: block;
  font-size: 24px;
  font-weight: 700;
  margin: 20px auto 0;
  min-height: 58px;
  min-width: 230px;
  padding: 10px 28px;
}

.boxAgradecimento--compact {
  padding: 20px;
  width: min(96%, 1100px);
}

.boxAgradecimento--compact .boxAgradecimento__photo {
  height: 150px;
}

.boxAgradecimento--compact .textHeader {
  font-size: 40px;
}

.boxAgradecimento--compact .textBody {
  font-size: 23px;
  margin-top: 12px;
}

@media (max-width: 900px) {
  .boxAgradecimento {
    max-height: 94vh;
    overflow-y: auto;
  }

  .boxAgradecimento__hero {
    gap: 14px;
    grid-template-columns: 1fr;
  }

  .boxAgradecimento__photo {
    height: 150px;
  }
}
</style>
